var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-setup',{ref:"setup",attrs:{"phaseTitle":_vm.$t('projects.stages.2'),"helpUrl":_vm.help.form,"markdownElements":_vm.formMarkdownElements}})}
var staticRenderFns = []

export { render, staticRenderFns }